{
  "v2": [
    {
      "code": ">QVR<",
      "name": "Consultar versión"
    },
    {
      "code": ">SRESET<",
      "name": "Reinicio"
    },
    {
      "code": ">QIO<",
      "name": "Estado I/O"
    },
    {
      "code": ">SSSU0011<",
      "name": "Apertura"
    },
    {
      "code": ">SSSU0211<",
      "name": "Cierre"
    },
    {
      "code": ">SDLC<",
      "name": "Limpiar LOG"
    },
    {
      "code": ">QDL<",
      "name": "Consultar LOG"
    },
    {
      "code": ">QHT<",
      "name": "Ubicacion"
    },
    {
      "code": ">QID<",
      "name": "Consultar ID"
    },
    {
      "code": ">QIP0<>QIP1<",
      "name": "Consultar Servidor y Puerto"
    },
    {
      "code": ">QSIM<",
      "name": "Consultar SIM"
    },
    {
      "code": ">QCEL<",
      "name": "Consultar RED"
    }
  ]
}
